import React from 'react';
import ModuleCard from 'components/module-card/ModuleCard';
import history from 'services/history';
import { Supplier } from 'types/supplier';

type SupplierItemModuleProps = {
  supplier: Supplier;
};

const SupplierItemModule: React.FC<SupplierItemModuleProps> = ({ supplier }) => {
  return (
    <ModuleCard
      idLabel={`ID ${supplier.id}`}
      title={supplier.company_name}
      subtitle={supplier.company_trade_name}
      status={supplier.formattedActive}
      statusTone={supplier.active ? 'success' : 'error'}
      fields={[
        { label: 'CPF/CNPJ', value: supplier.document_number },
        { label: 'Categoria', value: supplier.category },
        { label: 'E-mail', value: supplier.email },
        { label: 'Telefone', value: supplier.phone },
        { label: 'Rua', value: supplier.formattedStreet },
        { label: 'Cidade/UF', value: [supplier.formattedCity, supplier.formattedState].filter(Boolean).join(' - ') },
        { label: 'Data de registro', value: supplier.formattedCreatedAt },
      ]}
      onClick={() => history.push(`/suppliers/${supplier.id}`)}
    />
  );
};

export default SupplierItemModule;
